/**
 * Sessie 171: de link naar het aanmaakformulier (`/retouren/nieuw`) met
 * alles al ingevuld. Eén plek voor de parameternamen, zodat de klantkaart
 * en het formulier niet uit elkaar lopen.
 *
 * - `ordernummer`: het formulier zoekt de order zelf op.
 * - `mailadres`: het e-mailadres van de klant. Niet `email`: dat is een
 *   mail-id voor de voorstel-modus (besluit 15-09).
 * - `artikel`: de naam van de bestelregel; die wordt aangevinkt met het
 *   bestelde aantal. Een getal zonder naamtreffer telt als index.
 * - `klant`: klant-id zonder ordernummer; het formulier toont dan de
 *   laatste bestellingen om uit te kiezen (bij één: meteen die).
 */
export const RETOUR_PARAMS = {
  ordernummer: "ordernummer",
  mailadres: "mailadres",
  artikel: "artikel",
  klant: "klant",
} as const;

export function retourLink(invoer: {
  ordernummer?: string | null;
  mailadres?: string | null;
  artikel?: string | null;
  klant?: string | null;
}): string {
  const params = new URLSearchParams();
  if (invoer.ordernummer) params.set(RETOUR_PARAMS.ordernummer, invoer.ordernummer);
  if (invoer.mailadres) params.set(RETOUR_PARAMS.mailadres, invoer.mailadres);
  if (invoer.artikel) params.set(RETOUR_PARAMS.artikel, invoer.artikel);
  if (invoer.klant) params.set(RETOUR_PARAMS.klant, invoer.klant);
  const zoek = params.toString();
  return zoek ? `/retouren/nieuw?${zoek}` : "/retouren/nieuw";
}

/** "2x Brok Adult 12kg" (klantkaart) wordt "Brok Adult 12kg". */
export function productNaam(product: string): string {
  const treffer = /^\s*\d+\s*x\s+(.+)$/i.exec(product);
  return (treffer ? treffer[1] : product).trim();
}

function normaal(tekst: string): string {
  return tekst.toLowerCase().replace(/\s+/g, " ").trim();
}

/**
 * Welk artikel uit het orderzoek hoort bij de parameter `artikel`?
 * Eerst een exacte naam, dan een naam die de ander bevat, dan een index.
 * Geen treffer: -1 (dan vinkt het formulier niets aan).
 */
export function vindArtikel(namen: string[], artikel: string): number {
  const gezocht = normaal(productNaam(artikel));
  if (!gezocht) return -1;
  const exact = namen.findIndex((naam) => normaal(naam) === gezocht);
  if (exact >= 0) return exact;
  const deels = namen.findIndex((naam) => {
    const n = normaal(naam);
    return n.includes(gezocht) || gezocht.includes(n);
  });
  if (deels >= 0) return deels;
  if (/^\d+$/.test(artikel.trim())) {
    const index = Number(artikel.trim());
    if (index >= 0 && index < namen.length) return index;
  }
  return -1;
}
